export default __webpack_public_path__ + "static/media/logo-bank-bni.d7705d58.png";